module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/The-Hot-Zone.fe8e796.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/The-Hot-Zone.jpg
// module id = yrrp
// module chunks = 0